import React from 'react';
import { Target, Zap, Shield } from 'lucide-react';
import { companyInfo } from '../data/mock';

const About = () => {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description: companyInfo.mission
    },
    {
      icon: Zap,
      title: 'Innovation First',
      description: 'We leverage cutting-edge technologies and innovative approaches to deliver solutions that keep you ahead of the competition.'
    },
    {
      icon: Shield,
      title: 'Quality Assurance',
      description: 'Every project undergoes rigorous testing and quality checks. We don\'t just meet standards - we exceed them.'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-slate-50 via-white to-blue-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-blue-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-slate-100/30 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-blue-500 font-bold text-sm uppercase tracking-wider bg-blue-50 px-4 py-2 rounded-full border border-blue-200">
              Who We Are
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6">
            About <span className="text-blue-500">CRS Tech</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed">
            {companyInfo.description}
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-slate-200 hover:border-blue-300"
              >
                <div className="w-14 h-14 bg-blue-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{value.title}</h3>
                <p className="text-slate-600 leading-relaxed">{value.description}</p>
              </div>
            );
          })}
        </div>

        {/* Vision Statement */}
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-3xl p-12 text-center text-white shadow-2xl">
          <h3 className="text-3xl font-black mb-4">Our Vision</h3>
          <p className="text-xl max-w-3xl mx-auto leading-relaxed opacity-95">
            To revolutionize the IT industry by creating a seamless, all-in-one platform where businesses can access every technology service they need. We're not just building a company - we're building the future of IT solutions.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;